<template>
	<div class="styled-form__field">
		<label
			class="styled-form__label"
			:for="name"
		>{{ label }}</label>

		<span
			:class="['styled-form__error', {'is-visible': error}]"
		v-html="error">{{ error }}</span>

    <select
        :class="['styled-form__select', {'is-invalid': error}]"
        :id="name"
        :name="name"
        v-model="value"
        @input="$emit('input', $event.target.value)"
        @change="$emit('change', $event.target.value)"
        :disabled="disabled"
        @paste="$emit('paste', $event)"
    >
      <option v-for="(option, index) in options" :key="index" v-bind:value="option.id">{{ option.text }}</option>
    </select>
	</div>
</template>

<script>
	export default {
    model: {
      prop: 'value'
    },
    props: {
      options: {
        type: Array,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      error: {
        type: String
      },
      value: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      },
      autocomplete: {
        type: String,
        default: 'off'
      }
    }
  };
</script>
